import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';

const styles = theme => ({
  root: {
    marginTop: 16,
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.primary.light,
  },
});

export default withStyles(styles)(Table);
